/**
 * `@shn/substrate-types/errors` — extracted from monolithic `index.ts` per
 * CTO Platform Hardening Cycle Plan §4 directive 2026-05-24 (substrate-types
 * per-section split). Public API preservation forward: re-exported via barrel
 * `./index.ts`; consumers continue to import from `@shn/substrate-types`.
 */
// ============================================================================
// Substrate errors
// ============================================================================
export class SubstrateError extends Error {
    errorCode;
    context;
    constructor(message, errorCode, context) {
        super(message);
        this.errorCode = errorCode;
        this.context = context;
        this.name = 'SubstrateError';
    }
}
//# sourceMappingURL=errors.js.map